import { DocumentNode, OperationDefinitionNode } from 'graphql';

export const getOperationDefinitionFromDocument = (
  document: DocumentNode,
): OperationDefinitionNode | undefined =>
  document.definitions.find(
    (definition) => definition.kind === 'OperationDefinition',
  ) as OperationDefinitionNode | undefined;
